export type AgentChatDeepLinkType = {
  sessionId: string;
  messageId: string;
};

const SESSION_ID_PARAM = 'session_id';
const MESSAGE_ID_PARAM = 'message_id';

export const buildAgentChatMessageHref = (sessionId: string, messageId: string): string => {
  const params = new URLSearchParams({
    [SESSION_ID_PARAM]: sessionId,
    [MESSAGE_ID_PARAM]: messageId
  });

  return `/agent/#${params.toString()}`;
};

export const parseAgentChatDeepLink = (hash: string): AgentChatDeepLinkType | null => {
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const sessionId = params.get(SESSION_ID_PARAM)?.trim();
  const messageId = params.get(MESSAGE_ID_PARAM)?.trim();

  if (!sessionId || !messageId) return null;

  return { sessionId, messageId };
};
